import React from 'react';
import { bool, string } from 'prop-types';
import cx from 'classnames';

const propTypes = {
  /** Bar item should fill empty space */
  isFilling: bool,
  /** Bar item could shrink and wrap content if there is not enough empty space */
  canShrink: bool,
  /** Html tag in which the bar rendered. */
  tag: string,
};

const defaultProps = {
  tag: 'div',
};

const CLASS_ROOT = 'bar__item';

const BarItem = ({ className, isFilling, canShrink, tag, ...other }) => {
  const Tag = tag;
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--fill`]: isFilling,
      [`${CLASS_ROOT}--shrink`]: canShrink,
    },
    className
  );

  return <Tag className={classes} {...other} />;
};

BarItem.displayName = 'BarItem';
BarItem.propTypes = propTypes;
BarItem.defaultProps = defaultProps;

export default BarItem;



// WEBPACK FOOTER //
// ./src/components/Bar/BarItem.js